module.exports = __webpack_public_path__ + "static/media/angry.4596f783.svg";